import useSWRMutation from 'swr/mutation';
import { $POST } from './request';
import useUserStore from '@/store/userStore';
import useAppStore from '@/store/appStore';
import { Message } from '@arco-design/web-react';

export const useServiceSupport = () => {
  const userStore = useUserStore();
  const appStore = useAppStore();

  const {
    data,
    isMutating: loadSupport,
    trigger: triggerSupport,
  } = useSWRMutation('/trans/service-support', async () => {
    if (appStore.isKickOff) {
      Message.info($t('chat_session_status_8'));
      return;
    }

    const resp = await $POST<any>(
      `/miner-api/trans/service-support`,
      {},
      {
        headers: {
          lbeSession: userStore.sessionConfig.sessionId,
        },
      }
    );
    return resp;
  });

  return {
    data,
    loadSupport,
    triggerSupport,
  };
};
